import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withKeys as _withKeys, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "folder-picker" }
const _hoisted_2 = {
  key: 0,
  class: "folder-picker-chips"
}
const _hoisted_3 = ["title"]
const _hoisted_4 = {
  key: 0,
  class: "folder-picker-in"
}
const _hoisted_5 = {
  key: 1,
  class: "folder-picker-empty"
}
const _hoisted_6 = {
  key: 0,
  class: "folder-picker-list"
}
const _hoisted_7 = ["onMousedown"]
const _hoisted_8 = { class: "folder-picker-name" }
const _hoisted_9 = {
  key: 0,
  class: "folder-picker-path"
}
const _hoisted_10 = {
  key: 0,
  class: "folder-picker-empty"
}
const _hoisted_11 = {
  key: 3,
  class: "folder-picker-empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.selected.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selected, (f) => {
            return (_openBlock(), _createElementBlock("span", {
              key: f.slug,
              class: "folder-picker-chip",
              title: f.path
            }, [
              _createVNode(_component_svg_icon, { icon: "folder" }),
              _createTextVNode(_toDisplayString(f.name), 1),
              (f.parent)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, "in " + _toDisplayString(f.parent), 1))
                : _createCommentVNode("", true),
              _createVNode(_component_svg_icon, {
                icon: "x",
                title: "Remove",
                onClick: ($event: any) => (_ctx.remove(f.slug))
              }, null, 8, ["onClick"])
            ], 8, _hoisted_3))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.loadError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Couldn't load folders. You can file it from the Folders page later."))
      : (_ctx.loaded)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.query) = $event)),
              placeholder: "Search folders...",
              onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.open = true)),
              onKeydown: [
                _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.open = false), ["esc"])),
                _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (_ctx.pickFirst()), ["prevent"]), ["enter"]))
              ]
            }, null, 544), [
              [_vModelText, _ctx.query]
            ]),
            (_ctx.open || _ctx.query)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.matches, (f) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: f.slug,
                      class: "folder-picker-option",
                      onMousedown: _withModifiers(($event: any) => (_ctx.add(f.slug)), ["prevent"])
                    }, [
                      _createElementVNode("span", _hoisted_8, _toDisplayString(f.name), 1),
                      (f.parent)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(f.parent), 1))
                        : _createCommentVNode("", true)
                    ], 40, _hoisted_7))
                  }), 128)),
                  (!_ctx.matches.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.query ? 'No folders match "' + _ctx.query + '"' : 'Every folder is already picked'), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_11, "Loading folders..."))
  ]))
}